<template>
    <div class="organization-wrapper">

      <v-container class="pb-0">

        <v-layout row wrap class="organization">

          <!-- 左半分 #########################################-->
          <v-flex xs12 sm4 class="organization-list-left">

            <!-- 組織追加ボタン-->
            <organization-add-btn
              @child-action="showMessage"
            />
            <!-- 組織一覧 -->
            <div class="grey lighten-3 pt-2" id="organization-list">
              <ul>
                <tree-view
                  @child-action="selectOrganization"
                  :organization="treeData"
                  >
                </tree-view>
              </ul>
            </div>

          </v-flex>

          <!-- 右半分 #########################################-->
          <v-flex xs12 sm8 class="organization-detail-right">
            <!--組織詳細またはユーザー一覧-->
            <router-view
              ref="child"
              :selectedOrganizationId="selectedOrganizationId"
              :roles="roles"
              :organizations="organizations"
              @child-action="showMessage"
            >
            </router-view>
          </v-flex>

        </v-layout>

      </v-container>

      <!-- メッセージ スナックバー -->
      <v-snackbar
        v-model="showSnackbar"
        absolute top right
        :color="snackbarColor"
        :timeout="snackbarTimeout"
      >
      {{snackbarMessage}}
    </v-snackbar>

    </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'
import OrganizationAddBtn from '@/components/AccountOrganizationAdd'

export default {
  components: {
    OrganizationAddBtn
  },
  data () {
    return {
      edit: {},
      organizations: [],
      organizationsInTree: [],
      roles: [],
      btnDisable: false,
      validated: false,
      showForm: false,
      showDeleteDialog: false,

      selectedOrganizationId: null,
      preSelectedOrganizationId: null, // css用に前回の値を格納

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // rule
      emailRules: [
        v => validate.emailFormat(v) ||
            this.$t('account.vali-email-format')
      ],
      phoneRules: [
        v => validate.phoneFormat(v) ||
           this.$t('account.vali-phone-format'),
        v => v.length <= 128 || this.$t('account.vali-phone-length')
      ],
      treeData: {
        name: this.$store.getters.user.organizationName,
        organizationId: this.$store.getters.user.organizationId,
        children: []
      }
    }
  },
  methods: {
    init () {
      this.getTree() // TreeView.vueを使って再帰的に階層を表現
      this.getOrganizations() // TODO:ユーザー詳細画面に持っていく(持っていかない方法がありそう)
      this.roles = this.getRoles(this.$store.getters.user.roles[0]['name'])
    },
    getOrganizations () {
      http.request('get', '/service2/dashboard/api/Organizations/organizationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization list failed. (' + data.result + ')')
            return
          }
          this.organizations = data.organizations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getTree () {
      http.request(
      'get', '/service2/dashboard/api/Organizations/organizationTree/' +
      this.$store.getters.user.organizationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get tree failed. (' + data.result + ')')
            return
          }
          this.treeData.children = data.organizations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getRoles (role) {
      const viewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-not-limited-viewer') + ')'
      const limitedViewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-limited-viewer') + ')'
      // ここはハードコード
      switch (role) {
        case config.role.Root:
          return [{id: 1, name: 'Root'}, {id: 2, name: 'Administrator'}, {id: 3, name: 'Manager'}, {id: 4, name: 'Staff'}, {id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Administrator:
          return [{id: 2, name: 'Administrator'}, {id: 3, name: 'Manager'}, {id: 4, name: 'Staff'}, {id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Manager:
          return [{id: 3, name: 'Manager'}, {id: 4, name: 'Staff'}, {id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Staff:
          return [{id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Viewer:
          return []
        default:
          return []
      }
    },
    selectOrganization (organizationId) {
      this.selectedOrganizationId = organizationId
      this.$refs.child.init(organizationId)

      // TODO:かなり力技でcssを変えてる
      // 再帰的にcomponentを呼んでいるので選択しているIDを子に伝えづらい・リロードしてくれない
      if (this.preSelectedOrganizationId) {
        // 前回のcssを削除
        let preBox = document.getElementById('organization' + this.preSelectedOrganizationId)
        if (preBox) preBox.style.backgroundColor = ''
      }
      // 今回のcssを付与
      let box = document.getElementById('organization' + organizationId)
      box.style.backgroundColor = '#FFF'
      // 格納
      this.preSelectedOrganizationId = organizationId
    },
    showMessage (result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg
          this.snackbarColor = 'red lighten-3'
          this.snackbarTimeout = 6000
          this.showSnackbar = true
          break
        case 'success':
          this.snackbarMessage = msg
          this.snackbarColor = 'teal lighten-2'
          this.snackbarTimeout = 3000
          this.showSnackbar = true
          break
        default:
          return
      }
      this.getOrganizations()
      this.getTree()
    }
  },
  computed: {
    organizationsForAdd () {
      // TODO:変更検知して子のAccountOrganizationAddに伝える(もっといい方法ありそう)
      return this.organizations
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>

#organization-list{
  height: 700px;
  overflow-y: scroll;
  overflow-x: scroll;
  border-right: 4px #D0D5E2 solid !important;
}

.delete-organization{
  border-bottom: 1px #D0D5E2 solid;
}

.delete-organization p{
  text-align: right;
}

.delete-organization a{
  color: #000!important;
}

@media (min-width: 600px){
  .organization-list-left {
    height: 700px;
  }
}

/* リストの階層表示用 */
#organization-list ul {
  padding-left: 15px;
  list-style-type: none;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// AccountOrganizations.vue?09d6d74c